import React, {useMemo} from 'react';
import {Redirect, Route, Switch} from 'react-router';

import NoMatch from '../components/NoMatch';
import {useStatsigGateWorkspaceConsolidation} from '../util/rampFeatureFlags';
import {makeRoutes} from './makeRoutes';
import {RouteWithLayout} from './RouteWithLayout';

// When making changes to this file, please make sure to test routes and ensure performance does not regress.
// Changes to this file have a wide impact on the app and across multiple teams.
export const AppRoutes = React.memo(() => {
  const isWorkspaceConsolidationEnabled =
    useStatsigGateWorkspaceConsolidation();

  const filteredRoutes = useMemo(
    () =>
      makeRoutes(isWorkspaceConsolidationEnabled).filter(route =>
        'condition' in route ? route.condition !== false : true
      ),
    [isWorkspaceConsolidationEnabled]
  );

  return (
    <Switch>
      {filteredRoutes.map(route => {
        // Do not use the index as the key because this is NOT a static list of routes.
        // These are filtered down based on `condition`
        const key = Array.isArray(route.path)
          ? route.path.join('|')
          : route.path;

        if ('redirect' in route) {
          return <Redirect key={key} from={route.path} to={route.redirect} />;
        }

        const {RouteComponent, component: Component, ...rest} = route;

        return (
          <Route
            key={key}
            {...rest}
            render={o => {
              if (RouteComponent) {
                return (
                  <RouteComponent component={Component} {...o} {...rest} />
                );
              }

              return <Component {...o} {...rest} />;
            }}
          />
        );
      })}
      <RouteWithLayout routeName="NoMatch" component={NoMatch} />
    </Switch>
  );
});
